<template>
  <div>
    <b-container>
      <section>
        <div class="mt-5 mb-3 ml-0 mr-0 text-left">
          <b-card>
            <b-card-text>
              <h3 class="text-center">
                <b-btn
                  :pressed="RecipesButtonPressed"
                  :title="infoText('recipes')"
                  v-b-tooltip.hover.top
                  @click="showPublicRecipes"
                >
                  <font-awesome-icon icon="concierge-bell" class="mr-3" />Public Recipes
                </b-btn>
                <b-btn
                  :pressed="ResourcesButtonPressed"
                  :title="infoText('resources')"
                  v-b-tooltip.hover.top
                  @click="showPublicResources"
                >
                  <font-awesome-icon icon="utensils" class="mr-3" />Public Ingredients
                </b-btn>
                <b-btn
                  :pressed="OrganizationsButtonPressed"
                  :title="infoText('organizations')"
                  v-b-tooltip.hover.top
                  @click="showPublicOrganizations"
                >
                  <font-awesome-icon icon="building" class="mr-3" />Public Organizations
                </b-btn>
              </h3>
            </b-card-text>
            <hr>
            <div v-if="loading" class="spinner pt-1">
              <b-spinner label="Loading..."></b-spinner>
            </div>
            <b-card-text v-if="!loading">
              <div class="mb-3">
                <RecipesList v-if="RecipesButtonPressed" v-bind:recipes="recipes"></RecipesList>
                <ResourcesList v-if="ResourcesButtonPressed" v-bind:resources="resources"></ResourcesList>
                <OrganizationsList v-if="OrganizationsButtonPressed" v-bind:organizations="organizations" v-bind:type="chosenType"></OrganizationsList>
              </div>
              <div class="overflow-auto" v-if="showPagination">
                <b-pagination
                  v-model="pagination.currentPage"
                  :total-rows="pagination.totalCount"
                  :per-page="pagination.pageSize"
                  first-text="First"
                  prev-text="Prev"
                  next-text="Next"
                  last-text="Last"
                  align="center"
                  @input="loadGrid()">
                </b-pagination>
              </div>
            </b-card-text>
          </b-card>
        </div>
      </section>
    </b-container>
  </div>
</template>

<script>
  import RecipesList from '../components/recipes/RecipesList';
  import ResourcesList from '../components/resources/ResourcesList';
  import OrganizationsList from '../components/organizations/OrganizationsList';

  export default {
    name: 'PublicAssets',
    components: {
      RecipesList,
      ResourcesList,
      OrganizationsList
    },
    props: {
        preselect: {
          type: String,
          default: null
      }
    },
    data () {
      return {
        loading: true,
        chosenType: 'PUBLIC',
        RecipesButtonPressed: true,
        ResourcesButtonPressed: false,
        OrganizationsButtonPressed: false,
        resources: [],
        recipes: [],
        organizations: [],
        pagination: {
          currentPage: 1,
          totalCount: 0,
          pageSize: 9
        }
      }
    },
    created () {
      this.getRecipes();
    },
    mounted() {
        if (this.preselect==='ingredients'){
          this.showPublicResources();
        }
    },
    computed: {
      showPagination: function () {
        // display or not the pagination bar
        return this.pagination.totalCount > this.pagination.pageSize
      }
    },
    methods: {
      infoText(type) {
        if (type === 'recipes') return 'Recipes describe past participatory projects or ideas for new projects, aiming to capture the “how” and the “inside” knowledge.';
        if (type === 'resources') return 'Ingredients are digital assets that can be useful in a participatory project - recipe. They may be about policy recommendations, co-creation methodologies, digital tools, cultural heritage material etc.';
        if (type === 'organizations') return 'Organizations which have been involved in past participatory projects or may have relevant capacities or facilities and the interest to do so in the future.';
        return '';
      },
      showPublicRecipes() {
        // eventBus.$emit('sendChosenRecipeType', "OWN" )
        this.RecipesButtonPressed = true
        this.ResourcesButtonPressed = false
        this.OrganizationsButtonPressed = false
        this.pagination.currentPage = 1
        this.initGrid()
        this.getRecipes()
      },
      showPublicResources() {
        // eventBus.$emit('sendChosenRecipeType', "SHARE" )
        this.RecipesButtonPressed = false
        this.ResourcesButtonPressed = true
        this.OrganizationsButtonPressed = false
        this.pagination.currentPage = 1
        this.initGrid()
        this.getResources()
      },
      showPublicOrganizations() {
        this.RecipesButtonPressed = false
        this.ResourcesButtonPressed = false
        this.OrganizationsButtonPressed = true
        this.pagination.currentPage = 1
        this.initGrid()
        this.getOrganizations()
      },
      initRecipes: function () {
        this.recipes = []
      },
      initResources: function () {
        this.resources = []
      },
      initOrganizations: function () {
        this.organizations = []
      },
      initGrid: function() {
        this.loading = true
        this.recipes = []
        this.resources = []
        this.organizations = []
        this.pagination.totalCount = 0
      },
      loadGrid: function() {
        if (this.RecipesButtonPressed) {
          this.getRecipes();
        } else if (this.ResourcesButtonPressed) {
          this.getResources();
        } else {
          this.getOrganizations();
        }
      },
      getRecipes: function () {
        // Fetch a list of recipes
        let params = {
          status: this.chosenType,
          start: this.pagination.pageSize * (this.pagination.currentPage - 1),
          count: this.pagination.pageSize
        }
        // get data
        this.$store.dispatch('getRecipesList', params).then(
          data => {
            this.pagination.totalCount = data.totalCount
            this.initRecipes()
            this.recipes = data.results
            this.loading = false
          })
      },
      getResources: function () {
        // Fetch a list of resources
        let params = {
          status: this.chosenType,
          start: this.pagination.pageSize * (this.pagination.currentPage - 1),
          count: this.pagination.pageSize
        }
        // get data
        this.$store.dispatch('getResourcesList', params).then(
          data => {
            this.pagination.totalCount = data.totalCount
            this.initResources()
            this.resources = data.results
            this.loading = false
          })
      },
      getOrganizations: function () {
        // Fetch a list of organizations
        let params = {
          status: this.chosenType,
          start: this.pagination.pageSize * (this.pagination.currentPage - 1),
          count: this.pagination.pageSize
        }
        // get data
        this.$store.dispatch('getOrganizationList', params).then(
          data => {
            this.pagination.totalCount = data.totalCount
            this.initOrganizations()
            this.organizations = data.results
            this.loading = false
          })
      }
    }
  }
</script>

<style scoped>
  .btn {
    width:220px !important;
    background-color: #545b62;
    border-color: #545b62;
  }

  .btn.btn-secondary.active {
    background-color: #EE861D;
    border-color: #EE861D;
  }

  .spinner {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/PublicAssets.vue